module.exports = __webpack_public_path__ + "img/33375331.138896a3.png";